// jQuery free
import {lock, unlock} from 'tua-body-scroll-lock';
import {onDOMReady} from './dom';

(() => {
    function getLockTarget(dialogElement) {
        if (!(dialogElement instanceof HTMLElement)) {
            return dialogElement;
        }

        return dialogElement.querySelector('[data-body-scroll-lock-target]') || dialogElement;
    }

    onDOMReady(() => {
        document.addEventListener('kvik_event_modal_show_modal', function (event) {
            // Add small dealy because of wrong order lock/unlock
            setTimeout(() => {
                lock(getLockTarget(event.detail.dialogElement));
            }, 100);
        });
        document.addEventListener('kvik_event_modal_destroy', function (event) {
            setTimeout(() => {
                unlock(getLockTarget(event.detail.dialogElement));
            }, 300);
        });
    });
})();
